module.exports = __webpack_public_path__ + "static/media/young.7b8c6e59.jpg";